import { put, call } from "redux-saga/effects";
import mockConfig from "../config/mock-config";
import config from "../config/config";
import { getRequestHeaders } from "../utils/user";
import { globalActions, userActions } from "../actions/pro";

const SELF_API_HOST = config.API_HOST_URL;

export function* callAPI(
  apiURL,
  postData = "",
  requestMethod = "POST",
  isMultiPart = false,
  showLoader = true
) {
  try {
    let finalAPIUrl = SELF_API_HOST + apiURL;
    if (
      mockConfig &&
      (mockConfig.globalMock || (mockConfig[apiURL] && mockConfig[apiURL].mock))
    ) {
      if (mockConfig[apiURL] && mockConfig[apiURL].mockFile) {
        finalAPIUrl = "/_mocks/" + mockConfig[apiURL].mockFile;
        requestMethod = "GET";
      }
    }

    let data = false;
    if (showLoader === true) {
      yield put({ type: globalActions.SHOW_PAGE_LOADER });
    }
    if (postData === "") {
      const requestOptions = {
        method: "GET",
        responseType: "arraybuffer",
        headers: { ...getRequestHeaders() }
      };
      data = yield call(fetch, finalAPIUrl, requestOptions);
    } else {
      const requestOptions = {
        method: requestMethod,
        headers: { ...getRequestHeaders() },
        body:
          isMultiPart === true
            ? postData
            : JSON.stringify({
                ...postData
              })
      };
      data = yield call(fetch, finalAPIUrl, requestOptions);
    }
    if (showLoader === true) {
      yield put({ type: globalActions.HIDE_PAGE_LOADER });
    }

    //console.log("========", data.headers.get('Content-Type'))
    //logout if token expires
    if (data.status === 401) {
      yield put(userActions.logout());
      return false;
    } else if (data.status === 418) {
      forceReload();
      return false;
    } else if (data.headers.get("Content-Type") === "application/download") {
      forceDownload(yield data.blob());
      return true;
    }

    const response = yield data.json();
    return response;
  } catch (e) {
    yield put({ type: globalActions.HIDE_PAGE_LOADER });
    throw e;
  }
}

function forceReload() {
  //console.log('Clearing cache and hard reloading...')
  if (caches) {
    // Service worker cache should be cleared with caches.delete()
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });
  }
  // delete browser cache and hard reload
  window.location.reload(true);
}

function forceDownload(blob) {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute(
    "download",
    "report_" + Math.floor(Date.now() / 1000) + ".xlsx"
  ); //any other extension
  document.body.appendChild(link);
  link.click();
  link.remove();
}
